import {
  isDocumentary,
  isTVShowEpisode,
} from '../../shared/helpers/assetHelpers';
import {
  getAssetsItemListStructuredData,
  getMoviesItemListStructuredData,
  getTVSeriesStructuredData,
} from '../../shared/helpers/getStructuredData';

import type { Thing, WithContext } from 'schema-dts';
import type { CategoryPage } from '@vgtv/api-client/lib/page';
import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { SvpSeasonSliderComponent } from '@vgtv/api-client/lib/component/slider';

export const getCategoryPageStructuredData = ({
  pageConfig,
  categorySeasons,
  assets,
}: {
  pageConfig: CategoryPage;
  categorySeasons?: SvpSeasonSliderComponent;
  assets: SvpAssetAdditional[];
}) => {
  const data: (WithContext<Thing> | undefined)[] = [];

  // TV series metadata (with no assets there as Google can't interpret TVSeries, we need a regular asset list below)
  if (
    categorySeasons &&
    categorySeasons.categoryId === pageConfig.category.id
  ) {
    data.push(getTVSeriesStructuredData(pageConfig.category, categorySeasons));
  }

  if (!assets.length) {
    return data;
  }

  // Movies Carousel (Movie ItemList)
  if (assets.every(isDocumentary)) {
    data.push(getMoviesItemListStructuredData(assets));

    return data;
  }

  // VideoObject ItemList
  let normalizedAssets = assets;
  if (assets.every(isTVShowEpisode)) {
    // Sort TV show videos by episode number
    normalizedAssets = [...assets].sort(
      (a, b) => a.series!.episodeNumber - b.series!.episodeNumber
    );
  }
  data.push(getAssetsItemListStructuredData(normalizedAssets));

  return data;
};
